export const ROUTES_V2_PATHS = {
  login: '/login',
  signUp: '/signup',
  home: '/home',
  ovoCallback: '/stepup/callback/ovo',
  newBooking: '/bookings/new',
  bulkUpload: '/bulk-upload',
  bookings: '/bookings',
  redirectGfb: '/redirectGfb',
  errors: '/errors',
  verifyLKKP: '/verify-token',
  redirectGrabId: '/redirectGrabId',
  shopifyLanding: '/shopify/landing',
  shopifyHome: '/shopify',
  waybills: '/waybills',
  shopifySettings: '/shopify/settings',
  shopifyLink: '/shopify/link',
  errorGrabIDUser: '/error?newGrabIDUser=true',
  gfbLoginSuccessRedirect: '/login/success-redirect',
};

export const newBookingPageStateKey = {
  INIT_MODE: 'INIT_MODE',
};

export const newBookingPageStateModeValues = {
  MULTI: 'MULTI',
  SINGLE: 'SINGLE',
};

export const ROUTES_V2_KEYS = {
  login: 'login',
  signUp: 'signup',
  home: 'home',
  ovoCallback: 'ovoCallback',
  newBooking: 'newBooking',
  bulkUpload: 'bulkUpload',
  bookings: 'bookings',
  redirectGfb: 'redirectGfb',
  errors: 'errors',
  verifyLKKP: 'verifyToken',
  redirectGrabId: 'redirectGrabId',
  shopifyLanding: 'shopifyLanding',
  shopifyHome: 'shopify',
  waybills: 'waybills',
  shopifySettings: 'shopifySettings',
  shopifyLink: 'shopifyLink',
  gfbLoginSuccessRedirect: 'gfbLoginSuccessRedirect',
};
